import type { UseQueryResult } from "@tanstack/react-query";

/** Disabling a query alone retains cached data and permits manual refetches. */
export function visibleQuery<T>(query: UseQueryResult<T>, enabled: boolean) {
  const visible = {
    ...query,
    data: enabled ? query.data : undefined,
    error: enabled ? query.error : null,
    isLoading: enabled && query.isLoading,
    isFetching: enabled && query.isFetching,
    isError: enabled && query.isError,
    isSuccess: enabled && query.isSuccess,
  };
  return {
    ...visible,
    refetch: enabled ? query.refetch : () => Promise.resolve(visible),
  };
}
